import { effect, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { canAccessRoute, getFirstAccessibleRoute } from '@domain/aplication/navigation-permissions';
import { AplicationService } from '@services/aplication/aplication.service';

@Injectable({
    providedIn: 'root',
})
export class NavigationService {
    private readonly router = inject(Router);
    private readonly aplicationService = inject(AplicationService);

    /**
     * Monitors the selected aplication and redirects to the first accessible route
     * when the current URL is no longer accessible with the selected permissions.
     */
    readonly routePermissionMonitor = effect(() => {
        const roadId = this.aplicationService.selectedRoadId();

        if (roadId === null) {
            return;
        }

        const isAdmin = this.aplicationService.selectedAplicationIsAdmin();
        const hasImpersonate = this.aplicationService.selectedAplicationHasImpersonate();
        const currentUrl = this.router.url;

        if (!canAccessRoute(currentUrl, isAdmin, hasImpersonate)) {
            const fallback = getFirstAccessibleRoute(isAdmin, hasImpersonate);

            if (fallback) {
                this.router.navigate([fallback]);
            }
        }
    });
}
